import { AnimatedIcon } from '../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../shared/ui/AnimatedIcon/animations/cross.json';
import foodChoiceAnimation from '../../shared/ui/AnimatedIcon/animations/food-choice.json';
import quarkAnimation from '../../shared/ui/AnimatedIcon/animations/quark.json';
import robotAnimation from '../../shared/ui/AnimatedIcon/animations/robot.json';
import tickAnimation from '../../shared/ui/AnimatedIcon/animations/tick.json';
import vmAnimation from '../../shared/ui/AnimatedIcon/animations/vm.json';
import styles from './DevAnimations.module.css';

interface AnimationEntry {
    name: string;
    animationData: Record<string, unknown>;
    description: string;
}

const ANIMATIONS: AnimationEntry[] = [
    {
        name: 'robot',
        animationData: robotAnimation,
        description: 'Robot (ServiceRobot) — 14KB',
    },
    {
        name: 'cross',
        animationData: crossAnimation,
        description: 'X mark (failure screens) — 3KB',
    },
    {
        name: 'tick',
        animationData: tickAnimation,
        description: 'Checkmark (success screens) — 2.5KB',
    },
    {
        name: 'quark',
        animationData: quarkAnimation,
        description: 'Exclamation (NotSupportedScreen) — 3KB',
    },
    {
        name: 'vm',
        animationData: vmAnimation,
        description: 'Vending machine (WaitScreen, Connecting) — 6KB',
    },
    {
        name: 'food_choice',
        animationData: foodChoiceAnimation,
        description: 'Food carousel (SelectProduct) — 10KB',
    },
];

export const DevAnimations = () => {
    return (
        <div className={styles.page}>
            <h1 className={styles.title}>Animations (Dev Only)</h1>
            <div className={styles.grid}>
                {ANIMATIONS.map((anim) => (
                    <div key={anim.name} className={styles.row}>
                        <div className={styles.rowTitle}>
                            {anim.name} — {anim.description}
                        </div>
                        <div className={styles.animationBox}>
                            <AnimatedIcon animationData={anim.animationData} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
